import { useEffect, useRef } from "react";

// Та же механика «шторки», что у CTA->футер на главной (см. .fullpage-swiper
// в index.css): контент замирает на месте, а футер, идущий следом обычным
// потоком, наезжает на него сверху. На главной это бесплатно даёт
// position:sticky (CTA-слайд ровно 100vh), но здесь контент — статья
// произвольной длины, которую нельзя просто "прилепить" целиком, поэтому
// замираем его вручную: как только его низ доскроллил до низа вьюпорта,
// компенсируем дальнейший скролл через translateY, удерживая картинку на
// месте, пока футер (без какого-либо спец-позиционирования, z-index выше)
// въезжает в этот же экран снизу.
export function useFooterReveal() {
  const freezeRef = useRef(null);

  useEffect(() => {
    const freeze = freezeRef.current;
    if (!freeze) return;

    function onScroll() {
      const revealStart = freeze.offsetHeight - window.innerHeight;
      const delta = Math.max(0, window.scrollY - revealStart);
      freeze.style.transform = delta > 0 ? `translateY(${delta}px)` : "";
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return freezeRef;
}
